import { getDecimalsForFormattedCryptoPrecision } from './getDecimalsForFormattedCryptoPrecision';

export const CurrencyFormat = {
  symbol: true,
  code: false,
};

export class NumberFormatter {
  constructor(language) {
    this.language = language;
    this.formatOptions = {
      notation: 'standard',
    };
  }
  
  isCompactNumber() {
    this.formatOptions.notation = 'compact';
  }
  
  setMaxSignificantDigits (maxDigits) {
    this.formatOptions.maximumSignificantDigits = maxDigits;
  }

  setMaxFractionDigits (maxDigits) {
    this.formatOptions.maximumFractionDigits = maxDigits;
  }

  setMinimumFractionDigits(minDigits){
    this.formatOptions.minimumFractionDigits = minDigits;
  }
  
  setCurrency (currency, withSymbol) {
    this.formatOptions.currency = currency;
    this.formatOptions.style = 'currency';
    this.formatOptions.currencyDisplay = withSymbol === CurrencyFormat.symbol ? 'symbol' : 'code';
  }

  setUseGrouping (val) {
    this.formatOptions.useGrouping = val;
  }

  format (number) {
    const locale = `${this.language}-${this.language.toUpperCase()}`;
    const formatter = new Intl.NumberFormat(locale, this.formatOptions);
    
    return formatter.format(number);
  }

  // 0.00000001234 = >  0.00000001
  getAmountAndDecimalsForExtraSmallAmount(number, decimals) {
    let [integerPart, fractionPart] = parseFloat(number).toFixed(20).split('.');
    fractionPart = (fractionPart || '').replace(/0+$/, '');

    if (fractionPart && number > 0 && number < 0.01 && fractionPart.length > decimals) {
      const [minimumPossibleFraction] = fractionPart.match(/[0]{1,}[^0]/g);
      decimals = minimumPossibleFraction.length;
      if (decimals > 10) decimals = 10;
      fractionPart = fractionPart.substring(0, decimals);
      number = Number(`${integerPart}.${fractionPart}`);
    }
    return [number, decimals];
  }
}

function getStandardNumberFormatter (language, currency, withSymbol) {
  const numberFormatter = new NumberFormatter(language);
  if (currency !== null) {
    numberFormatter.setCurrency(currency, withSymbol);
  }
  
  return numberFormatter;
}

function getCompactNumberFormatter (language, currency, withSymbol) {
  const numberFormatter = getStandardNumberFormatter(language, currency, withSymbol);
  numberFormatter.isCompactNumber();
  
  return numberFormatter;
}

export function formatNumberCompact (number, language, currency = null, withSymbol = null) {
  const numberFormatter = getCompactNumberFormatter(language, currency, withSymbol);
  
  return numberFormatter.format(number);
}

export function formatNumberStandard (number, language, currency = null, withSymbol = null, minimumFractionDigits= null) {
  if (number === undefined || number === null) {
    return '';
  }
  
  const numberFormatter = getStandardNumberFormatter(language, currency, withSymbol);

  if (number > 0 && number < 0.01) {
    let decimals = 2;
    [number, decimals] = numberFormatter.getAmountAndDecimalsForExtraSmallAmount(number, decimals);
    numberFormatter.setMaxFractionDigits(decimals);
  }

  if (minimumFractionDigits !== null) {
    numberFormatter.setMinimumFractionDigits(minimumFractionDigits);
  }
  
  return numberFormatter.format(number);
}

export function formatNumberForCrypto(number, language, cryptoCurrency) {
  const decimals = getDecimalsForFormattedCryptoPrecision(cryptoCurrency);

  const numberFormatter = new NumberFormatter(language);
  numberFormatter.setMaxFractionDigits(decimals);

  return numberFormatter.format(number);
}

// Transform one number to another number format
// Example: 112345.120000 => 112345.12 , 0.00000162 => 0.000001
export function formatNumberWithDecimals(amount, maximumFractionDigits, transformExtraSmallAmount= false){
  const numberFormatter = new NumberFormatter('en');
  if(transformExtraSmallAmount) {
    [amount, maximumFractionDigits] = numberFormatter.getAmountAndDecimalsForExtraSmallAmount(amount, maximumFractionDigits);
  }
  numberFormatter.setUseGrouping(false);
  numberFormatter.setMaxFractionDigits(maximumFractionDigits);

  return numberFormatter.format(amount);
}
